module.exports = "<app-slider></app-slider>\r\n<app-eventos></app-eventos>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/inicio/inicio.component.html
// module id = ../../../../../src/app/inicio/inicio.component.html
// module chunks = main